import AllInstallations from './AllInstallations';
export default AllInstallations;